import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { ProfileSalaryRequest } from 'src/app/models/profile-salary.model';
import { ResponseObject } from 'src/app/models/response-object.model';

import { HumanResourcesService } from 'src/app/services/human-resources.service';
import { PayrollService } from 'src/app/services/payroll.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';

@Component({
  selector: 'app-employee-inactive-list',
  templateUrl: './employee-inactive-list.component.html',
  styleUrls: ['./employee-inactive-list.component.scss']
})
export class EmployeeInactiveListComponent implements OnInit {

  permissionType = PermissionTypeEnum;

  employees: any[] = [];
  employeesFilter: any[] = [];

  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    pageIndex: 0,
    startElement: 0,
    lastElement: 0
  };

  selectedEmployee: any = null;

  hiring = false;
  contractEmployees = false;

  selectedProfile = null;
  selectedPosition = null;

  contractProfiles = [];
  positions = [];

  createProfileSalary = false;
  newSalary: ProfileSalaryRequest = null;

  registerDate: string = new Date().toISOString().split('T')[0];
  dischargeDate: string = '';

  constructor(
    private toastService: ToastrService,
    private humanResourcesService: HumanResourcesService,
    private payrollService: PayrollService,
    private roleService: RolesAndPermissionsService
  ) { }

  ngOnInit(): void {
    this.getEmployees();
    this.setProfileContracts(null);
    this.setAllPositions();
  }

  getEmployees() {
    this.payrollService.getInactiveEmployees().subscribe({
      next: (response: any) => {
        this.employees = response.data || [];
        this.pagination.total = this.employees;
        this.resetPagination();
      },
      error: () => {
        this.toastService.error('Error al cargar los empleados inactivos', 'Error');
      }
    });
  }

  setProfileContracts(idSelected: number) {
    this.humanResourcesService.getProfileContract().subscribe({
      next: (response: ResponseObject) => {
        this.contractProfiles = response.data || [];

        if (idSelected) {
          this.selectedProfile = idSelected;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error?.message || 'Error al cargar perfiles');
      }
    });
  }

  setAllPositions() {
    this.roleService.getPositions().subscribe({
      next: (response: ResponseObject) => {
        this.positions = response.data || [];
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error?.message || 'Error al cargar posiciones');
      }
    });
  }

  resetPagination() {
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  startRehiring(item: any) {
    this.selectedEmployee = item;
    this.hiring = true;

    this.selectedProfile = null;
    this.selectedPosition = item?.position?.id || null;
  }

  cancelRehiring() {
    this.hiring = false;
    this.selectedEmployee = null;
    this.selectedProfile = null;
    this.selectedPosition = null;
    this.contractEmployees = false;

    this.registerDate = new Date().toISOString().split('T')[0];
    this.dischargeDate = '';
  }

  showActualProfileSalary() {
    if (!this.selectedProfile) {
      this.toastService.warning('Debe seleccionar un perfil', 'Advertencia');
      return;
    }

    const profile = this.contractProfiles.find((p: any) => {
      return p.id + '' === this.selectedProfile + '';
    });

    if (!profile) {
      this.toastService.warning('No se encontró el perfil seleccionado', 'Advertencia');
      return;
    }

    profile['isPro'] = !!profile.proAmount;
    profile['isBonus'] = !!profile.bonusAmount;
    profile['isRelation'] = !!profile.relationAmount;

    this.createProfileSalary = false;
    this.newSalary = profile;
  }

  closeModalProfileSalary(value: number) {
    this.createProfileSalary = false;
    this.newSalary = null;

    if (value && value !== -1) {
      this.setProfileContracts(value);
    }
  }

  rehireEmployee() {
    if (!this.registerDate) {
      this.toastService.warning('Debe seleccionar una fecha de alta');
      return;
    }

    if (!this.selectedEmployee) {
      this.toastService.warning('Debe seleccionar un empleado', 'Advertencia');
      return;
    }

    if (!this.selectedProfile || !this.selectedPosition) {
      this.toastService.warning('Debe seleccionar perfil y posición', 'Advertencia');
      return;
    }

    const salary: any = this.contractProfiles.find((c: any) => {
      return c.id + '' === this.selectedProfile + '';
    });

    if (!salary) {
      this.toastService.warning('No se encontró el perfil seleccionado', 'Advertencia');
      return;
    }

    const employeeId = this.selectedEmployee.employee?.id || this.selectedEmployee.id;

    const request: any = {
      employees: [employeeId],
      position: this.selectedPosition,

      relationAmount: salary.relationAmount,
      proAmount: salary.proAmount,
      bonusAmount: salary.bonusAmount,

      rAguinaldo: salary.rAguinaldo,
      rBono: salary.rBono,
      rVacaciones: salary.rVacaciones,
      rIggs: salary.rIggs,

      pAguinaldo: salary.pAguinaldo,
      pBono: salary.pBono,
      pVacaciones: salary.pVacaciones,

      bAguinaldo: salary.bAguinaldo,
      bBono: salary.bBono,
      bVacaciones: salary.bVacaciones,

      type: salary.type,
      shift: salary.shift,
      payment: salary.payment,
      registerDate: this.registerDate,
      dischargeDate: this.dischargeDate,
    };

    this.contractEmployees = true;

    this.humanResourcesService.rehireEmployees(request).subscribe({
      next: () => {
        this.toastService.success('Empleado recontratado con éxito', 'Éxito');
        this.cancelRehiring();
        this.getEmployees();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error?.message || 'Error al recontratar empleado', 'Error');
        this.contractEmployees = false;
      }
    });
  }
}